import React from 'react';
import { Section } from './ui/Section';
export function Stats() {
  return <Section variant="alt" data-id="element-202">
      <div className="bg-white border-2 border-brand-primary rounded-lg p-6 shadow-card" data-id="element-203">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-204">
          <div data-id="element-205">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-206">
              +8.000
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-207">
              Psicólogos activos
            </div>
          </div>
          <div data-id="element-208">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-209">
              600+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-210">
              Consultas lanzadas
            </div>
          </div>
          <div data-id="element-211">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-212">
              200K+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-213">
              Páginas material
            </div>
          </div>
          <div data-id="element-214">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-215">
              5h+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-216">
              Ahorradas/semana
            </div>
          </div>
        </div>
      </div>
    </Section>;
}